import { Pagination, paginationDisplayRange, paginationInfo } from "@robe/core";
import { Box, FlexProps, Icon, IconProps, useTheme } from "@xcorejs/ui";
import { XcoreTheme } from "./theme";

interface PaginatorProps extends FlexProps {
  pagination: Pagination;
  setPage?: (n: number) => void;
}

export const Paginator = ({ pagination, setPage, ...props }: PaginatorProps) => {
  const theme = useTheme() as XcoreTheme;
  const info = paginationInfo(pagination);
  const range = paginationDisplayRange(info);

  const paginationProps = theme.pagination.default;
  const buttonProps = theme.pagination.button;
  const buttonActiveProps = theme.pagination.buttonActive;
  const moreProps = theme.pagination.more;

  return (
    <Box as="ul" {...paginationProps} {...props}>
      {range.map((r, i) => {
        if (r === "dots") {
          return <NumberIcon key={i} {...moreProps} />;
        }

        const active = r === info.page;

        return (
          <Box key={i} {...buttonProps} {...(active && buttonActiveProps)} onClick={() => !active && setPage?.(r + 1)}>
            <Box>{r + 1}</Box>
          </Box>
        );
      })}
    </Box>
  );
};

const NumberIcon = (props: IconProps) => {
  return (
    <Icon
      svg={
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
          <path fill="#1e1e1e" fillRule="evenodd" d="M2,3 L2,5 L0,5 L0,3 L2,3 Z M5,3 L5,5 L3,5 L3,3 L5,3 Z M8,3 L8,5 L6,5 L6,3 L8,3 Z" />
        </svg>
      }
      {...props}
    />
  );
};
